import { Box } from '@mui/material';
import { SearchingApps } from 'application/Shared/Components/App/SearchingApps';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { WizardContext } from '../Wizard';

export const SearchingAppsStep = () => {
    const { toNextStep } = useContext(WizardContext);
    const { t } = useTranslation();

    return (
        <Box p="64px">
            <SearchingApps
                onDone={toNextStep}
                progressBarText={t(
                    'SearchingAppsStep.progressBar.setupIntegration'
                )}
            />
        </Box>
    );
};
